<script setup lang="ts">
const userAuth = useCookie('auth_token', { readonly: true, default: () => false })

const {data: user} = useFetch(`https://www.${useBenevoltDomain()}/api/user/me`, {
  headers: {
    'Authorization': userAuth.value ? `Bearer ${userAuth.value}` : null,
  },
  transform: (data) => data.user
})

const links = computed(() => {
  if (user.value) {
    if (user.value.account_type === 'volunteer') {
      return [{
        label: 'Accueil',
        icon: 'i-ph-house-duotone',
        to: '/dashboard',
        external: true,
      }, {
        label: 'Recherche',
        icon: 'i-ph-magnifying-glass-duotone',
        to: '/recherche',
        external: true,
      }, {
        label: 'Messages',
        icon: 'i-ph-chat-duotone',
        to: '/conversation',
        external: true,
      }, {
        label: 'Aide',
        to: 'https://aide.benevolt.fr/fr/',
        external: true,
        target: '_blank'
      }]
    } else if (user.value.account_type === 'organization') {
      return [{
        label: 'Retour sur l\'Espace Asso',
        icon: 'i-ph-sign-in',
        to: `https://espaceasso.${useBenevoltDomain()}`,
        external: true,
      }]
    } else {
      return [{
        label: 'Recherche',
        icon: 'i-ph-magnifying-glass-duotone',
        to: '/recherche',
        external: true,
      }, {
        label: 'Messages',
        icon: 'i-ph-chat-duotone',
        to: '/conversation',
        external: true,
      }, {
        label: 'Admin',
        icon: 'i-ph-gear-duotone',
        to: `https://espaceasso.${useBenevoltDomain()}/admin`,
        external: true,
      }]
    }
  }

  return [{
    label: 'Rechercher une mission',
    icon: 'i-ph-magnifying-glass',
    to: '/recherche',
    external: true,
  }, {
    label: 'Espace Asso',
    icon: 'i-ph-users-three-duotone',
    to: 'https://asso.benevolt.fr'
  }, {
    label: 'Connexion',
    icon: 'i-ph-sign-in',
    to: '/se-connecter',
    external: true,
  }, {
    label: 'Inscription',
    icon: 'i-ph-user-plus-duotone',
    to: '/se-connecter',
    external: true,
  }]
})

const accountLinks = computed(() => {
  return [{
    label: 'Mon profil',
    icon: 'i-ph-user-duotone',
    to: `/settings/profile`,
    external: true,
  }]
})
</script>

<template>
  <UHeader :ui="{right: 'gap-5', left: 'gap-0'}">
    <template #left>
      <NuxtLink to="/" external>
        <svg class="h-7 text-red-500" viewBox="0 0 160 28" xmlns="http://www.w3.org/2000/svg"><title>Logo de Benevolt</title><path d="M5.78 25.484v1.06H0V0h6.305v7.444c1.593-1.088 3.486-1.72 5.518-1.72 5.66 0 10.246 4.895 10.246 10.932 0 6.037-4.588 10.93-10.247 10.93-2.26 0-4.35-.78-6.043-2.102zM55.785 7.48V6.433h-6.13v20.233h6.13v-14c.964-1.31 2.848-1.31 3.186-1.31 2.946 0 2.946 2.53 2.946 2.53v12.78h6.13v-12.78s0-8.37-7.253-8.37c-.3 0-3.65 0-5.008 1.962zM150.868 0h6.257v6.913l2.875-.05v4.823h-2.875v15.9h-6.257v-15.9h-2.822V6.863h2.822V0zM138.85 0h6.437v27.586h-6.436V0zm-13.793 27.586c-6.094 0-11.034-4.94-11.034-11.034s4.94-11.035 11.034-11.035c6.095 0 11.035 4.94 11.035 11.035 0 6.094-4.94 11.034-11.035 11.034zm0-6.305c2.612 0 4.73-2.116 4.73-4.728 0-2.612-2.118-4.73-4.73-4.73-2.61 0-4.73 2.118-4.73 4.73 0 2.612 2.12 4.73 4.73 4.73zM92.874 6.438h6.434l4.336 12.103 3.674-12.103h6.705l-7.14 21.15h-6.434l-7.576-21.15zM85.65 26.74c-5.762 2.097-12.134-.874-14.23-6.636-2.098-5.762.34-11.794 6.104-13.892 5.762-2.097 11.67.896 13.77 6.658.25.686.44 1.376.575 2.062.058.3-13.906 4.742-13.804 5.024.836 2.296 3.525 2.585 5.76 1.772.698-.255 3.005-1.91 2.653-2.878l5.646-2.055c.396 6.8-5.593 9.624-6.476 9.945zm-.727-14.365c-.6-1.646-2.976-2.292-5.308-1.443-2.332.848-3.737 2.87-3.138 4.518l8.446-3.075zM35.01 27.585c-6.13 0-11.102-4.94-11.102-11.033 0-6.094 4.97-11.035 11.103-11.035 6.134 0 10.047 4.94 10.047 11.035 0 .725-.055 1.435-.163 2.12-.047.3-14.69-.297-14.69 0 0 2.43 2.43 3.613 4.807 3.613.744 0 3.48-.762 3.48-1.785h6.008c-1.954 6.484-8.547 7.086-9.487 7.086zm4.23-13.66c0-1.742-2.01-3.153-4.493-3.153-2.482 0-4.494 1.41-4.494 3.152h8.988zM11.035 21.86c2.902 0 5.255-2.33 5.255-5.204 0-2.875-2.354-5.205-5.256-5.205S5.78 13.78 5.78 16.657c0 2.874 2.352 5.205 5.254 5.205z" class="fill-current" fill-rule="evenodd"/></svg>
      </NuxtLink>
    </template>

    <template #right>
      <template v-if="!user">
        <UNavigationMenu :items="[{label: 'Rechercher une mission', to: '/recherche', external: true, icon: 'i-ph-magnifying-glass'}]" variant="link" class="hidden md:flex" />
        <UButton class="px-4 hidden lg:flex rounded-full whitespace-nowrap" color="neutral" variant="subtle" to="https://asso.benevolt.fr" external>Espace Asso</UButton>
        <div class="flex border-gray-200 dark:border-gray-800 h-10 border-s border-solid hidden md:flex"></div>
        <UNavigationMenu :items="[{label: 'Connexion', to: '/se-connecter', external: true}]" variant="link" class="hidden sm:flex" />
        <UButton class="px-4 hidden sm:flex rounded-full" to="/se-connecter" external>Inscription</UButton>
      </template>
      <template v-else>
        <UNavigationMenu :items="links" variant="link" class="hidden lg:flex" />
        <div class="flex border-gray-200 dark:border-gray-800 h-10 border-s border-solid hidden lg:flex"></div>
        <UDropdownMenu :items="accountLinks" :ui="{ content: 'w-(--reka-dropdown-menu-trigger-width)' }">
          <UButton variant="ghost" external class="hidden md:flex" color="neutral">
            <UAvatar :src="user.avatar_converted_url ?? '/im/user-avatar-default.png'" />
            <div class="w-25 truncate text-muted text-left">{{user.public_name}}</div>
            <UIcon name="i-ph-caret-down" class="text-dimmed" />
          </UButton>
        </UDropdownMenu>
      </template>
    </template>

    <template #body>
      <UButton variant="ghost" to="/settings/account" external class="w-full" v-if="user" >
        <UAvatar :src="user.avatar_converted_url ?? '/im/user-avatar-default.png'" />
        <div>{{user.public_name}}</div>
      </UButton>
      <UNavigationMenu :items="links" orientation="vertical" />
    </template>
  </UHeader>
</template>